export default __webpack_public_path__ + "/_/specialEmoji.d1f29118.png";